import React from "react";
import {
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { useIntl } from "react-intl";
import { messages } from "./SearchResult.messages";
import { User } from "../../../../../Models/User";
import { displayUser } from "../../../../../Utils/User";
import { Query } from "../SearchField/SearchField";
import { useCustomerFeatures } from "../../../../../Providers/CustomerProvider/CustomerProvider";
import { hasFeatureEnabled } from "../../../../FeatureController/FeatureController";
import { CustomerFeatureType } from "../../../../../generated/customersettings-api";

interface Props {
  query?: Query;
  users?: User[];
  onCreateNew: () => void;
  onSelect: (user: User) => void;
  onInvite: () => void;
  isLoading: boolean;
}

const SearchResult = (props: Props) => {
  const { isLoading, query, users, onSelect, onCreateNew, onInvite } = props;
  const intl = useIntl();
  const customerFeatures = useCustomerFeatures();
  const doFormatPersonNumber = hasFeatureEnabled(
    CustomerFeatureType.UsesPersonNumber,
    customerFeatures
  );

  if (users && users.length === 0 && query?.personNumber && !isLoading) {
    return (
      <>
        <Typography>
          {intl.formatMessage(messages.noMatchPersonNumber)}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={onCreateNew}
        >
          {intl.formatMessage(messages.createUserButton)}
        </Button>
      </>
    );
  }

  if (users && users.length === 0 && query?.phoneNumber && !isLoading) {
    return (
      <>
        <Typography>
          {intl.formatMessage(messages.noMatchPhoneNumber)}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={onCreateNew}
        >
          {intl.formatMessage(messages.createUserButton)}
        </Button>
      </>
    );
  }

  if (users && query?.email && !isLoading) {
    return (
      <>
        {users.length === 0 ? (
          <>
            <Typography>{intl.formatMessage(messages.noMatchEmail)}</Typography>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={onInvite}
            >
              {intl.formatMessage(messages.inviteUserButton)}
            </Button>
          </>
        ) : (
          <List>
            {users?.map((user: User) => (
              <ListItem button onClick={onInvite}>
                <ListItemIcon>
                  <AddIcon />
                </ListItemIcon>
                <ListItemText
                  primary={displayUser(doFormatPersonNumber, user)}
                />
              </ListItem>
            ))}
          </List>
        )}
      </>
    );
  }

  return (
    <>
      <List>
        {users?.map((user: User) => (
          <ListItem button onClick={() => onSelect(user)}>
            <ListItemIcon>
              <AddIcon />
            </ListItemIcon>
            <ListItemText primary={displayUser(doFormatPersonNumber, user)} />
          </ListItem>
        ))}
      </List>
    </>
  );
};

export default SearchResult;
